import { TestCount } from 'libs/end-to-end/src/tests-utils';

export const testCount = (overrides?: Partial<TestCount>): TestCount => {
  return {
    passing: 1,
    failing: 1,
    incomplete: 1,
    ...(overrides ?? {}),
  };
};
